import Choices from "choices.js";
import Swiper from "swiper";

export default class Global {

    constructor() {
        this.initChoices();
        this.initUsps();
        this.initTransactionSlider();
    }

    initChoices() {
        const elements = document.querySelectorAll('.js-choice');
        let choices;

        elements.forEach(element => {

            const searchEnabled = element.dataset.noSearch ? false : true;

            const choices = new Choices(element, {
                searchEnabled: searchEnabled
            });
        });
    }

    initUsps() {
        if (document.getElementById('usps')) {
            new Swiper('#usps .swiper-container', {
                slidesPerView: 1,
                spaceBetween: 30,
                breakpoints: {
                    576: {
                        slidesPerView: 2,
                        slidesPerGroup: 2
                    },
                    992: {
                        slidesPerView: 4,
                    }
                },
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets',
                },
            });
        }
    }

    initTransactionSlider() {
        if (document.getElementById('transactionSlider')) {
            new Swiper('#transactionSlider .swiper-container', {
                slidesPerView: 1,
                spaceBetween: 30,
                breakpoints: {
                    576: {
                        slidesPerView: 2,
                        slidesPerGroup: 2
                    },
                    992: {
                        slidesPerView: 4,
                    }
                }
            });
        }
    }
}
